import { memo, useEffect } from 'react';
import { Dimensions } from 'react-native';
import {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { Box, Image, useLayout } from '@bonanza-social/moonlight';
import { PrizeWallGlowProps } from './PrizeWallGlow.types';

function PrizeWallGlow({ animationDuration, ...rest }: PrizeWallGlowProps) {
  const [layout, onLayout] = useLayout();
  const animatedValue = useSharedValue(1);
  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ scale: animatedValue.value }],
  }));

  useEffect(() => {
    if (layout.width && layout.height) {
      const { width: windowWidth, height: windowHeight } =
        Dimensions.get('window');
      const scale = Math.max(
        windowWidth / layout.width,
        windowHeight / layout.height,
      );

      animatedValue.value = withTiming(scale, {
        duration: animationDuration,
        easing: Easing.linear,
      });
    }
  }, [layout, animationDuration, animatedValue]);

  return (
    <Box animatedStyle={animatedStyle} onLayout={onLayout} {...rest}>
      <Image name="prizeWall.prizeGlow" width="100%" height="100%" />
    </Box>
  );
}

export default memo(PrizeWallGlow);
